import { render, staticRenderFns } from "./leoAddLkNew.vue?vue&type=template&id=5499ccfc&scoped=true&"
import script from "./leoAddLkNew.vue?vue&type=script&lang=js&"
export * from "./leoAddLkNew.vue?vue&type=script&lang=js&"
import style0 from "./leoAddLkNew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./leoAddLkNew.vue?vue&type=style&index=1&id=5499ccfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499ccfc",
  null
  
)

export default component.exports